import React from 'react'
import AdminLayout from '../../layouts/AdminLayout'
import Profile from '../../components/Profile'

const AdminProfile = () => {
  return (
    <AdminLayout>
    <Profile />
    </AdminLayout>
  )
}

export default AdminProfile
